import { siteData, type StoryItem } from "@/store/siteData";

// Türkçe karakter duyarlı slug üretimi
export function slugify(s: string): string {
  return (s || "")
    .toLowerCase()
    .replace(/ç/g, "c").replace(/ğ/g, "g").replace(/ı/g, "i")
    .replace(/ö/g, "o").replace(/ş/g, "s").replace(/ü/g, "u")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

// Bir makalenin URL slug'ı (slug alanı varsa onu, yoksa başlıktan üretir)
export function storySlug(s: StoryItem): string {
  return s.slug || slugify(s.title) || `makale-${s.id}`;
}

export function getStories(): StoryItem[] {
  return siteData.getStories().items;
}

export function getStoryBySlug(slug: string): StoryItem | undefined {
  return getStories().find((s) => storySlug(s) === slug);
}

// body yoksa kısa açıklamadan paragraf üretir
export function storyParagraphs(s: StoryItem): string[] {
  return (s.body || s.desc || "").split(/\n{2,}/).map((p) => p.trim()).filter(Boolean);
}
